// extracted by mini-css-extract-plugin
module.exports = {"displayNamePill":"clinical-portal-3__DisplayNamePill__displayNamePill"};